<script lang="ts" setup>
import { DialogHeader, DialogTitle, DialogDescription, DialogFooter, DialogClose } from '~/components/ui/dialog'
import { Button } from '~/components/ui/button'

const { t } = useI18n()
const emit = defineEmits(['next'])

const points = [
	{ icon: 'custom:jobtoken-onboarding-1', text: t('Create or complete tasks and earn tokens. ') },
	{ icon: 'custom:jobtoken-onboarding-2', text: t('Pay for services within the platform or exchange for perks and benefits.') },
	{ icon: 'custom:jobtoken-onboarding-3', text: t('Once listed on exchanges, JobToken will become a valuable asset you can buy, sell, or hold.') }
]
</script>

<template>
	<div class="p-6 text-white">
		<div class="absolute w-full h-1/2 top-0 left-0 bg-gradient-to-b from-[#00AD6B] to-black z-0"></div>
		<div class="flex justify-center gap-2 mb-6 relative">
			<div v-for="step in 3" class="w-2 h-2 rounded-full" :class="step === 1 ? 'bg-slate-500' : 'bg-gray-200'">
			</div>
		</div>

		<div class="text-center relative">
			<img src="/img/jobtoken/logo-onboarding.png" class="mx-auto mb-6" alt="" />

			<DialogHeader>
				<DialogTitle class="text-3xl font-bold">
					{{ t('JobToken') }}
				</DialogTitle>
				<DialogDescription class="text-slate-400 mb-6">
					{{ ('Blockchain based reward system') }}
				</DialogDescription>
			</DialogHeader>

			<!-- Пункты -->
			<div class="space-y-4 mb-8">
				<div v-for="(point, index) in points" :key="index" class="flex items-center gap-3">
					<div class="relative mr-2">
						<div class="w-8 h-8 rounded-md bg-gray-700 absolute -top-[5px] left-[5px] rotate-[15deg]"></div>
						<div
							class="w-8 h-8 rounded-md bg-gradient-to-br from-gray-200 to-gray-400 shadow-sm border border-gray-200 relative z-2 flex items-center justify-center">
							<Icon :name="point.icon" size="16" class="text-gray-700" />
						</div>
					</div>
					<span class="text-left text-slate-400 text-sm">{{ point.text }}</span>
				</div>
			</div>

			<DialogFooter class="flex flex-col gap-4">
				<DialogClose class="w-full" as-child>
					<Button class="w-full bg-gray-800 hover:bg-gray-900">
						{{ $t('Cancel') }}
					</Button>
				</DialogClose>

				<Button @click="emit('next')" variant="primary" class="w-full">
					{{ $t('Next') }}
				</Button>
			</DialogFooter>
		</div>
	</div>
</template>

